export default __webpack_public_path__ + "static/media/joshua.b24b15de.jpg";